import {BaseModel} from "@/models/base/BaseModel";

export class DigitalSignageTV extends BaseModel {
  assignedDateTime: Date;
  lastActive: Date;
  token: string | null;
  loginURL: string | null;
  brand: string | null;
  model: string | null;
  osName: string | null;
  osVersion: string | null;
  browserName: string | null;
  browserVersion: string | null;
  screenSize: string | null;
  isAuth: boolean;
  isDigitalSignageTV: boolean;
  userId: string | null;
  userName: string | null;
  userStatus: string | null;
  userType: string;
  imageUrl: string | null;
  friendlyName: string | null;
  ua: string | null

  constructor() {
    super();
    this.assignedDateTime = new Date();
    this.lastActive = new Date();
    this.token = null;
    this.facilityId = null;
    this.loginURL = null;
    this.brand = null;
    this.model = null;
    this.osName = null;
    this.osVersion = null;
    this.browserName = null;
    this.browserVersion = null;
    this.screenSize = null;
    this.isAuth = false;
    this.isDigitalSignageTV = true;
    this.userId = null;
    this.userName = null;
    this.userStatus = null;
    this.userType = "staff";
    this.imageUrl = null;
    this.friendlyName = null;
    this.ua = null;
  }
}